import { Component, Inject, Input, OnInit } from '@angular/core';
import { ComponentService } from '../../services/component.service';
import { EventEmitter } from 'events';
import { NicaMaster } from '../nica-master-component/nica-master.component';

@Component({
  selector: 'app-show-rentri-elenco-movimenti',
  templateUrl: './show-rentri-elenco-movimenti.component.html',
  styleUrls: ['./show-rentri-elenco-movimenti.component.css'],
})
export class ShowRentriElencoMovimentiComponent extends NicaMaster implements OnInit {
  @Input () dataToSend:{idElenco:number,api:string,guid:string};
  idElenco:number;
  api: string;
  guid:string
  constructor(private componentService:ComponentService
    
  ){
    super()
  }
  ngOnInit(): void {
    if(this.dataToSend){
      this.api=this.dataToSend.api
      this.idElenco=this.dataToSend.idElenco
      this.guid=this.dataToSend.guid
    }
    /*
    if(this.data){
      this.api=this.data.api
      
      this.idElenco=this.data.idElenco
      this.guid=this.data.guid
    }*/
  }
  emettiChiusuraCaption(evt){

    if(evt == 'close'){
      this.componentService.destroyCurrentOpenPopUpByGuid(this.guid);
      this.componentService.destroyOutputComponent();
    }

  }
  emettiChiusura($event:EventEmitter){
    this.componentService.destroyCurrentOpenPopUpByGuid(this.guid);
    this.componentService.destroyOutputComponent();


  }
  
}